export const PRODUCT_CATEGORIES = {
  'Bebidas Calientes con café': 'B',
  'Bebidas Calientes sin café': 'B',
  'Bebidas frías con café': 'B',
  'Bebidas frías sin café': 'R',
  'Refrescos': 'R',
  'Pan': 'P',
  'Bebidas de Empleados': 'B',
  'Panes de Empleados': 'P',
  'Smoothie': 'S',
  'Frappé': 'F',
  'Promociones': 'P',
  'Extras': 'E',
  'Brunch': 'B',
  'Temporada': 'T'
} as const;

export type ProductCategory = keyof typeof PRODUCT_CATEGORIES;

export const PRODUCT_CATEGORY_MAP: Record<string, ProductCategory> = {
  'Americano Espresso (8oz)': 'Bebidas Calientes con café',
  'Americano espresso en las rocas (16oz)': 'Bebidas frías con café',
  'Americano espresso en las rocas (8oz)': 'Bebidas frías con café',
  'Brunch con Bebidas': 'Brunch',
  'Cafe del Dia (16oz)': 'Bebidas Calientes con café',
  'Cafe del Dia (8oz)': 'Bebidas Calientes con café',
  'Dirty Chai (16oz)': 'Bebidas Calientes con café',
  'Dirty Chai (8oz)': 'Bebidas Calientes con café',
  'Empleado - Americano Espresso (8oz)': 'Bebidas de Empleados',
  'Empleado - Croissant Chocolate': 'Panes de Empleados',
  'Empleado - Croissant Jamón y Queso': 'Panes de Empleados',
  'Empleado - Empanada Jamón y Queso': 'Panes de Empleados',
  'Empleado - Empanada Lomo Canadiense': 'Panes de Empleados',
  'Empleado - Leche Especial (Soya, Almendra, Avena)': 'Bebidas de Empleados',
  'Empleado - Muffin Chocolate': 'Panes de Empleados',
  'Galleta de Nuez': 'Pan',
  'Latte (16oz)': 'Bebidas Calientes con café',
  'Mocca (8oz)': 'Bebidas Calientes con café',
  'Muffin Queso con Arandano': 'Pan',
  'Pan de muerto': 'Pan',
  'Pumpkin Spice Latte en las rocas (16oz)': 'Bebidas frías con café',
  'Smoothie Mango (16oz)': 'Smoothie',
  'Té Earl Grey Lavanda': 'Bebidas Calientes sin café',
  'Té verde': 'Bebidas Calientes sin café',
  '2x1 combo (capuccino + pan)': 'Promociones',
  'Agua Mineral (sabor) lata San Peligrino': 'Refrescos',
  'Baguette Pizza (Salami)': 'Pan',
  'Chai Latte (16oz)': 'Bebidas Calientes sin café',
  'Chai Latte (8oz)': 'Bebidas Calientes sin café',
  'Chai latte en las rocas Grande': 'Bebidas frías sin café',
  'Croissant Chocolate': 'Pan',
  'Croissant Jamón y Queso': 'Pan',
  'Empanada Lomo Canadiense': 'Pan',
  'Empleado - Americano espresso en las rocas (8oz)': 'Bebidas de Empleados',
  'Empleado - Baguette Philadelphia y Jamón': 'Panes de Empleados',
  'Empleado - Chocolate artesenal (8oz)': 'Bebidas de Empleados',
  'Empleado - Empanada Selva Negra': 'Panes de Empleados',
  'Empleado - Galleta Integral': 'Panes de Empleados',
  'Empleado - Tisana (8oz)': 'Bebidas de Empleados',
  'Frappuccino (16oz)': 'Bebidas frías con café',
  'Frappé Chocolate (16oz)': 'Bebidas Calientes sin café',
  'Frappé Taro (16oz)': 'Frappé',
  'Galleta Integral': 'Pan',
  'Latte (8oz)': 'Bebidas Calientes con café',
  'Naranjada (16oz)': 'Bebidas frías sin café',
  'Pan de Muerto + Americano o Chocolate (16oz)': 'Promociones',
  'Tisana Grande': 'Bebidas Calientes sin café',
  'Té Masala Chai': 'Bebidas Calientes sin café',
  '2x1 cappuccino o americano': 'Promociones',
  'Agua de coco (refresco lata)': 'Refrescos',
  'Baguette Philadelphia y Jamón': 'Pan',
  'Café de olla (16oz)': 'Bebidas Calientes con café',
  'Chocolate caliente (16oz)': 'Bebidas Calientes sin café',
  'Chocolate caliente (8oz)': 'Bebidas Calientes sin café',
  'Chocolate Oaxaqueño (8oz)': 'Bebidas Calientes sin café',
  'Empanada Selva Negra': 'Pan',
  'Empleado - Chocolate Oaxaqueño (8oz)': 'Bebidas de Empleados',
  'Empleado - Crossant jamón y queso': 'Panes de Empleados',
  'Empleado - Matcha Latte (8oz)': 'Bebidas de Empleados',
  'Espresso (carga extra - 1oz)': 'Bebidas Calientes con café',
  'Espresso doble': 'Bebidas Calientes con café',
  'Frappé Matcha (16oz)': 'Bebidas Calientes sin café',
  'Grano de cafe': 'Extras',
  'Latte en las rocas (16oz)': 'Bebidas frías con café',
  'Limonada (16oz)': 'Bebidas frías sin café',
  'Matcha latte en las rocas (16oz)': 'Bebidas frías sin café',
  'Muffin Chocolate': 'Pan',
  'Ofrenda - Frio con chocolate y mango (16oz)': 'Temporada',
  'Pan de Muerto + Americano o Chocolate (8oz)': 'Promociones',
  'Pumpkin Spice Frappe': 'Temporada',
  'Smoothie Maracuyá (16oz)': 'Smoothie',
  'Smoothie Piña (16oz)': 'Smoothie',
  'Brunch Sin Bebidas': 'Brunch',
  'Cappuccino (8oz)': 'Bebidas Calientes con café',
  'Chai latte en las rocas (16oz)': 'Bebidas frías sin café',
  'Chocolate artesenal (16oz)': 'Bebidas Calientes sin café',
  'Chocolate artesenal (8oz)': 'Bebidas Calientes sin café',
  'Empleado - Cappuccino (8oz)': 'Bebidas de Empleados',
  'Empleado - Chocolate caliente (8oz)': 'Bebidas de Empleados',
  'Empleado - Dirty Chai (8oz)': 'Bebidas de Empleados',
  'Empleado - Galleta de Nuez': 'Panes de Empleados',
  'Empleado - Latte (8oz)': 'Bebidas de Empleados',
  'Empleado - Mocca (8oz)': 'Bebidas de Empleados',
  'Empleado - Tisana en las rocas (8oz)': 'Bebidas de Empleados',
  'Flat White (8oz)': 'Bebidas Calientes con café',
  'Frappuccino Mocca (16oz)': 'Bebidas frías con café',
  'Frappé Chocolate Artesanal Mexicano (16oz)': 'Bebidas Calientes sin café',
  'Frappé Strawberry Cream (16oz)': 'Bebidas Calientes sin café',
  'Matcha Latte (8oz)': 'Bebidas Calientes sin café',
  'Mocca (16oz)': 'Bebidas Calientes con café',
  'Muffin Frutos Rojos': 'Pan',
  'Pumpkin Spice Latte (8oz)': 'Temporada',
  'Shot extra espresso': 'Bebidas Calientes con café',
  'Smoothie Fresa (16oz)': 'Smoothie',
  'Tisana en las rocas Grande': 'Bebidas frías sin café',
  'Viernes 2x1 en Smoothies': 'Promociones',
  'Agua mineral San Peligrino': 'Refrescos',
  'Americano Espresso (16oz)': 'Bebidas Calientes con café',
  'Café de olla (8oz)': 'Bebidas Calientes con café',
  'Calaverita - Frappe con Vainilla y Canela (16oz)': 'Temporada',
  'Cappuccino (16oz)': 'Bebidas Calientes con café',
  'Chocolate Oaxaqueño (16oz)': 'Bebidas Calientes sin café',
  'Coca-Cola Lata': 'Refrescos',
  'Empanada Jamón y Queso': 'Pan',
  'Empleado - Cafe del Dia (8oz)': 'Bebidas de Empleados',
  'Empleado - Chai Latte (8oz)': 'Bebidas de Empleados',
  'Empleado - Flat White (8oz)': 'Bebidas de Empleados',
  'Empleado - Muffin Frutos Rojos': 'Panes de Empleados',
  'Empleado - Muffin Queso con Arandano': 'Panes de Empleados',
  'Espresso (1oz)': 'Bebidas Calientes con café',
  'Extra Perla Explosiva': 'Extras',
  'Frappé Crema Irlandesa (16oz)': 'Bebidas Calientes sin café',
  'Galleta de Nuez (6)': 'Pan',
  'Leche Especial (Soya, Almendra, Avena)': 'Extras',
  'Matcha Latte (16oz)': 'Bebidas Calientes sin café',
  'Naranjada Grande': 'Bebidas frías sin café',
  'Pumpkin Spice Latte (16oz)': 'Temporada',
  'Smoothie Tamarindo (16oz)': 'Smoothie',
  'Tisana (8oz)': 'Bebidas Calientes sin café',
  'Tisana en las rocas (8oz)': 'Bebidas frías sin café',
  'Crossant jamón y queso': 'Pan',
  'Empleado - Baguette Pizza (Salami)': 'Panes de Empleados',
  'Muffin Mocha': 'Pan'
};

export function getProductCategory(productName: string): ProductCategory | 'Sin categoría' {
  const exactMatch = PRODUCT_CATEGORY_MAP[productName];
  if (exactMatch) {
    return exactMatch;
  }
  
  const normalizedName = productName.trim();
  const normalizedMatch = PRODUCT_CATEGORY_MAP[normalizedName];
  if (normalizedMatch) {
    return normalizedMatch;
  }
  
  return 'Sin categoría';
}

export function getAllCategories(): ProductCategory[] {
  return Object.keys(PRODUCT_CATEGORIES) as ProductCategory[];
}
